export default __webpack_public_path__ + "static/media/left.15ec880e.svg";